import React, { Component } from 'react';
import { Button, Row, Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default class ItemLibro extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {}
  renderPrice() {
    if (this.props.data.precio === 0 && this.props.data.precioElectronico === 0) {
      return (
        <div key={this.props.data.route}>
          <Link to={`/libros/${this.props.data.route}`}>
            <Button bsClass="btn compraBtn" style={{ fontFamily: 'Source Sans Pro', fontSize: '14pt' }}>
              Descargar
            </Button>
          </Link>
          ,
          <p
            style={{
              color: '#e4e400',
              fontSize: '16pt',
              fontFamily: 'Source Sans Pro',
            }}
          >
            {`Libro gratuito`}
          </p>
          ,
        </div>
      );
    }
    return [
      <Link to={`/libros/${this.props.data.route}`} key={this.props.data.route}>
        <Button bsClass="btn compraBtn" style={{ fontFamily: 'Source Sans Pro', fontSize: '14pt' }}>
          Información
        </Button>
      </Link>,
      // <p
      //   style={{
      //     color: '#e4e400',
      //     fontSize: '16pt',
      //     fontFamily: 'Source Sans Pro',
      //   }}
      // >
      //   {`$ ${parseFloat(this.props.data.precio).toFixed(2)} + Envío`}
      //   <br />
      //   {this.props.data.precioElectronico &&
      //     `$ ${parseFloat(this.props.data.precioElectronico).toFixed(2)} Libro Electrónico`}
      // </p>,
    ];
  }
  render() {
    return (
      <div style={{ backgroundColor: '#352a35', padding: 10 }}>
        <Row>
          <Col xs={6}>
            <Image
              src={this.props.data.img}
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                display: 'block',
                marginTop: 20,
                maringBottom: 20,
              }}
              responsive
            />
          </Col>
          <Col xs={6}>
            <div>
              <p
                style={{
                  color: 'white',
                  fontSize: '18pt',
                  fontWeight: 'bold',
                  fontFamily: 'Source Sans Pro',
                }}
              >
                {this.props.data.title}
              </p>
              <p
                style={{
                  color: '#686871',
                  fontFamily: 'Source Sans Pro',
                  fontSize: '14pt',
                }}
              >
                by {this.props.data.author}
              </p>
              {this.renderPrice()}
            </div>
          </Col>
        </Row>
        <div>
          <p
            style={{
              color: 'white',
              fontSize: '16pt',
              fontWeight: 'bold',
              fontFamily: 'Source Sans Pro',
            }}
          >
            Descripción
          </p>
          <p
            style={{
              color: 'white',
              fontSize: '14pt',
              fontFamily: 'Source Sans Pro',
            }}
          >
            {this.props.data.desc}
          </p>
        </div>
      </div>
    );
  }
  componentDidMount() {}
  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/views/libros/itemlibro.js